import { useEditor } from 'craft/hooks/useEditor';

export const useChildNodes = (nodeId: string) => {
  const { query } = useEditor();
  const node = query.node(nodeId).get();
  if (!node) {
    return [];
  }
  if (!node.data.nodes) {
    return [];
  }
  return node.data.nodes;
};
